import React, {useMemo} from 'react';
import debounce from 'debounce';
import {usePagination, useTable} from 'react-table';
import DataTableView from './DataTable-view';

const DELAY = 450;

const DataTable = ({
                     data: tableData,
                     totalPages,
                     totalResultCount,
                     page,
                     setPage,
                     customClassNames = {},
                     columnsList,
                     showPagination = true,
                     columnStorageKey = null,
                     onColumnChange,
                     allowSorting = false,
                     onSortChange,
                     sortColumnName,
                     sortDirection,
                     loading
                   }) => {
  const data = useMemo(
    () => tableData ? [...tableData] : [],
    [tableData]
  );
  const columns = useMemo(
    () => [...columnsList],
    []
  );
  const tableProps = useTable(
    {
      columns,
      data,
      initialState: {pageIndex: page}, // Pass our hoisted table state
      manualPagination: true, // Tell the usePagination
      // hook that we'll handle our own data fetching
      // This means we'll also have to provide our own
      // pageCount.
      pageCount: totalPages,
    },
    usePagination
  );

  const gotoPage = pageIndex => {
    setPage(pageIndex);
    tableProps.gotoPage(pageIndex);
  };

  const nextPage = debounce(() => {
    setPage(page + 1);
    tableProps.nextPage();
  }, DELAY);

  const previousPage = debounce(() => {
    setPage(page - 1);
    tableProps.previousPage();
  }, DELAY);

  const customTableProps = {
    ...tableProps,
    gotoPage,
    nextPage,
    pageIndex: page,
    previousPage,
    totalResultCount,
    customClassNames,
    showPagination,
    columnStorageKey,
    onColumnChange,
    allowSorting,
    onSortChange,
    sortColumnName,
    sortDirection,
    loading
  };

  return (
    <DataTableView {...customTableProps} />
  );
};

export default DataTable;